import React, {useEffect} from 'react';
import {Image, Nav} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {MenuExternalLink} from './MenuExternalLink.tsx';
import {MenuInternalLink} from './MenuInternalLink.tsx';
import {useStoreExecutions} from '../../../../store/useStoreExecutions';
import {sideMenuManager} from '../../../../hooks/MenuManager';
import {useStoreSavs} from '../../../../store/useStoreSavs';
import {useStoreShopClosure} from '../../../../store/useStoreShopClosure.ts';
import {useNotifications} from '../../../../hooks/useNotifications';
import {useEventProvider} from '../../../../providers/EventProvider.tsx';
import SideMenuHeader from '../SideMenuHeader';
import SideMenuUser from '../SideMenuUser';
import {FlowerFeastButton} from '../../flower_feast/FlowerFeastButton';
import SideMenuDelivery from '../SideMenuDelivery';
import SideMenuFooter from '../SideMenuFooter';
import SideMenuImpersonate from './SideMenuImpersonate.tsx'


export const MenuContent = () => {
    const executionsInPendingCount = useStoreExecutions(
        (state) => state.executionsInPendingCount,
    )
    const savsOpenedCount = useStoreSavs((state) => state.savsOpenedCount)
    const getSavs = useStoreSavs((state) => state.getSavs)
    const {newSavs} = useEventProvider()
    const {state, isAdmin, user, handleNavItem} = sideMenuManager()
    const shopIsClosed = useStoreShopClosure((state) => state.shopIsClosed)
    const closeDateStart = useStoreShopClosure((state) => state.closeDateStart)
    const closeDateEnd = useStoreShopClosure((state) => state.closeDateEnd)
    const {handlePlay} = useNotifications()
    const initialiseShopIsClosed = useStoreShopClosure(
        (state) => state.initialiseShopIsClosed,
    )
    const shopClosureInitialised = useStoreShopClosure(
        (state) => state.initialised,
    )

    // Permet de charger une première fois les données avec Zustand
    useEffect(() => {
        getSavs()

        if (newSavs.data && newSavs.data.count > 0) {
            getSavs(true)
        }

        if (!shopClosureInitialised) {
            initialiseShopIsClosed()
        }
    }, [newSavs])

    const menus = [
        {
            component: <SideMenuHeader />,
        },
        {
            component: <SideMenuUser />,
        },
        {
            component: <SideMenuImpersonate user={user} />,
        },
        {
            title: 'Mon tableau de bord',
            pathName: 'tableau-de-bord',
            icon: 'home',
            classNames: 'bg-orange',
            header: true,
        },
        {
            title: 'Mon florajet',
            image: 'images/logo-f-white-sm.svg',
            header: true,
            children: [
                {
                    title: 'Mes commandes',
                    children: [
                        {
                            title: 'Mes exécutions',
                            pathName: 'executions',
                            badge:
                                executionsInPendingCount > 0
                                    ? executionsInPendingCount
                                    : false,
                        },
                        {
                            title: 'Mes transmissions',
                            pathName: 'transmissions',
                        },
                        {
                            title: 'Saisir une commande',
                            pathName: 'saisir-commande',
                            disable: !user.constraints?.transmitter,
                        },
                        {
                            title: 'Mes SAV',
                            pathName: 'sav',
                            badge:
                                savsOpenedCount > 0 ? savsOpenedCount : false,
                        },
                    ],
                },
                {
                    title: 'Mon compte',
                    children: [
                        {
                            title: 'Mon magasin',
                            pathName: 'magasin',
                        },
                        {
                            title: 'Ma comptabilité',
                            pathName: 'prelevements',
                            disable: !isAdmin,
                        },
                        {
                            title: 'Mes congés/fermetures',
                            pathName: 'conges',
                        },
                        {
                            title: 'Mes périmètres de livraison',
                            pathName: 'perimetre',
                        },
                        {
                            title: "Mon stock d'accessoires",
                            pathName: 'accessoires',
                            disable: !user.constraints?.accessories,
                        },
                        {
                            title: 'Livreurs',
                            pathName: 'livreurs',
                            disable: !isAdmin,
                        },
                    ],
                },
                {
                    title: 'La boutique Florajet',
                    children: [
                        {
                            title: `Accessoires à commander ${
                                shopIsClosed
                                    ? `(fermé du ${closeDateStart} au ${closeDateEnd})`
                                    : ''
                            }`,
                            pathName: `${
                                shopIsClosed ? 'tableau-de-bord' : 'mes-achats'
                            }`,
                        },
                        {
                            title: "Mon historique d'achat",
                            pathName: 'historique',
                        },
                    ],
                },
            ],
        },
        {
            title: 'Mes outils',
            header: true,
            icon: 'tools',
            children: [
                {
                    title: 'Catalogue',
                    pathName: 'catalogue',
                },
                {
                    title: 'Documentation',
                    pathName: 'documentation',
                },
                {
                    title: 'Partenaires',
                    pathName: 'partners',
                },
            ],
        },
        {
            title: 'Aide',
            header: true,
            icon: 'question-circle',
            children: [
                {
                    title: 'FAQ',
                    pathName: 'https://reseau.florajet.com/hc/fr',
                    externalLink: true,
                },
                {
                    title: 'Vidéos',
                    pathName: 'videos',
                },
                {
                    title: 'Logiciels',
                    children: [
                        {
                            title: 'Microsoft Teams',
                            pathName:
                                'https://www.microsoft.com/fr-fr/microsoft-365/microsoft-teams/download-app',
                            externalLink: true,
                        },
                        {
                            title: 'Adobe Reader PDF',
                            pathName:
                                'https://get.adobe.com/fr/reader/otherversions/',
                            externalLink: true,
                        },
                        {
                            title: 'PDF Foxit Reader',
                            pathName: 'https://www.foxit.com/fr/pdf-reader/',
                            externalLink: true,
                        },
                    ],
                },
            ],
        },
        {
            title: 'Envoyer un message',
            header: true,
            pathName: `https://reseau.florajet.com/hc/fr/requests/new?tf_anonymous_requester_email=${
                user.Email
            }&tf_17938548426652=${user.CodeFl}&tf_21633409142684=${
                user.Email
            }&tf_17938439495580=${String(user.Telephone).replace(/\./g, '')}`,
            externalLink: true,
            classNames: 'bg-orange',
            icon: 'comments',
        },
        {
            title: 'Paramètres',
            header: true,
            icon: 'cog',
            children: [
                {
                    title: 'Utilisateur',
                    pathName: 'Utilisateurs',
                },
                {
                    title: 'Tester la sonnerie',
                    onClick: handlePlay,
                },
            ],
        },
        {
            component: <FlowerFeastButton />,
        },
        {
            component: <SideMenuDelivery />,
        },
        {
            component: <SideMenuFooter />,
        },
    ]

    function buildMenu(menus) {
        return menus.map(function (menu, index) {
            let menuView = null

            if (menu.disable === undefined || menu.disable === false) {
                if (menu.component) {
                    menuView = buildComponent(menu.component);
                } else if (menu.pathName && menu.header) {
                    menuView = buildHeaderWithPathname(menu, index);
                } else if (menu.pathName) {
                    menuView = buildMenuWithPathName(menu, index);
                } else if (!menu.pathName && menu.header) {
                    menuView = buildHeaderWithoutPathname(menu, index);
                } else {
                    menuView = (
                        <div key={index} className={'ml-3 mt-1'}>
                            {menu.image && (
                                <Image src={menu.image} className={'mr-1'} />
                            )}
                            <u>{menu.title}</u>
                        </div>
                    )
                }

                if (menu.onClick) {
                    menuView = buildMenuOnClick(menu, index);
                }

                if (menu.children) {
                    menuView = buildMenuChildren(menu, menuView);
                }
            }

            return menuView
        })
    }

    function buildComponent(component: React.JSX.Element): React.JSX.Element {
        return (
            <Row>
                <Col>{component}</Col>
            </Row>
        )
    }

    function buildHeaderWithPathname(menu, index: number) {
        let className = menu.externalLink
            ? 'nav-link btn btn-block text-left py-1 bg-primary'
            : 'btn btn-block text-left py-1'

        className += ` ${menu.classNames}`

        return menu.externalLink ? (
            <MenuExternalLink menu={menu} className={className} />
        ) : (
            <MenuInternalLink
                menu={menu}
                index={index}
                className={className}
                onClick={handleNavItem}
            />
        )
    }

    function buildMenuWithPathName(menu, index: number) {
        let className = menu.externalLink
            ? 'ml-2 nav-link'
            : `ml-2 btn btn-block text-left pt-0 pb-1`

        className += ` ${menu.classNames}`

        return menu.externalLink ? (
            <MenuExternalLink menu={menu} className={className} />
        ) : (
            <MenuInternalLink
                menu={menu}
                index={index}
                className={className}
                onClick={handleNavItem}
            />
        )
    }

    function buildHeaderWithoutPathname(menu, index: number) {
        return (
            <div
                key={index}
                className={`${menu.classNames} w-100 bg-primary rounded text-white mt-1`}
                style={{
                    fontSize: '14.4px',
                    padding: '3.6px 14.4px',
                }}>
                {menu.icon && (
                    <FontAwesomeIcon
                        icon={menu.icon}
                        color={'white'}
                        className={'mr-1'}
                    />
                )}
                {menu.image && <Image src={menu.image} className={'mr-1'} />}
                {menu.title}
            </div>
        );
    }

    function buildMenuOnClick(menu, index: number) {
        return (
            <Nav.Link
                active={state.modalShow}
                eventKey={index}
                key={index}
                className={'ml-2'}
                onClick={menu.onClick}>
                {menu.title}
            </Nav.Link>
        )
    }

    function buildMenuChildren(menu, menuView) {
        return (
            <>
                {menuView}
                {buildMenu(menu.children)}
            </>
        );
    }

    return buildMenu(menus)
}
